import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';
import { environment } from 'src/environments/environment';
import { IAppState } from '../../../store/state/app.state';
import {select, Store} from '@ngrx/store';
import { PagePlaceSelectStart } from '../../../store/actions/page.actions';
import { IRace } from '../../../models/race.interface';
import { IHorse } from '../../../models/horse.interface';
import { ITotrace } from '../../../models/totrace.interface';
import { MonitoringService } from '../../utility/monitoring/monitoring.service';
import { Observable } from 'rxjs';
import { CartService } from '../../cart/cart.service';
import { element } from 'protractor';
import {UrlControllerService} from '../../url-controller.service';
import {selectIdentify} from '../../../store/selectors/identify.selectors';
import {IIdentify} from '../../../models/identify.interface';
import {includes} from 'lodash';

/**
 * Service with http call to populate race sections
 */
@Injectable({
  providedIn: 'root',
})
export class RaceService extends UrlControllerService {
  public identify$: Observable<IIdentify>;
  /**
   * Url of api
   */
  private apiUrlFixed: string;
  private apiUrlTot: string;

  /**
   * Costructor service
   * @param http take http client module
   * @param _store ngrx store to select first place
   * @param monitoringService service to log and monitoring
   */

  private token = null;
  constructor(
    private http: HttpClient,
    public _store: Store<IAppState>,
    private monitoringService: MonitoringService,
    private cartService: CartService
  ) {
    super(_store);
    // this.apiUrlFixed = this.apiUrlSelected + 'rest/program/race/';
    this.apiUrlTot = environment.apiUrlTot + 'rest/palinsesti/corsa/full/';
    this.identify$ = this._store.pipe(select(selectIdentify));
    this.identify$.subscribe((x) => {
      if (x) {
        this.token = x.token;
      }
    });
  }

  /**
   * Call service and return observable of IMenu
   * @returns Observable<IRace>
   */
  getRace(id: number): Observable<IRace> {
    return this.http.get<any>(this.apiUrlSelected + 'rest/program/race/' + id).pipe(
      map((element) => {
        let handicap = 0;
        element.race.lavagna = 0;
        element.race.win = false;
        element.race.pl2 = false;
        element.race.pl3 = false;
        element.race.pl4 = false;
        element.race.pl5 = false;
        element.race.pl6 = false;
        element.race.notPl2 = false;
        element.race.notPl3 = false;
        element.race.notPl4 = false;
        element.race.shortMx = false;
        element.race.lenghtsX = false;
        element.race.dispersionX = false;

        // Filtro le scommesse in base al environment.excludeBet
        // element.race.qf = element.race.qf.filter((quota) => this.excludeBets(quota));
        if (element.race.horse) {
          element.race.horse.forEach((horse) => {
            element.race.qf.forEach((quota) => {
              let qt = [];
              switch (quota.id) {
                case '1': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => qf.esito === horse.number);
                    if (qt.length > 0 && qt[0].quota > 0) {
                      element.race.lavagna = element.race.lavagna + 100 / qt[0].quota;
                      horse.quotaVincente = qt[0];
                      if (!element.race.win) {
                        element.race.win = true;
                      }
                    }
                  }
                  break;
                }
                case '2': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => qf.esito === horse.number);
                    if (qt.length > 0) {
                      horse.quotaPiazzato2 = qt[0];
                      if (!element.race.pl2) {
                        this._store.dispatch(new PagePlaceSelectStart('2'));
                        element.race.pl2 = true;
                      }
                    }
                  }
                  break;
                }
                case '3': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => qf.esito === horse.number);
                    if (qt.length > 0) {
                      horse.quotaPiazzato3 = qt[0];
                      if (!element.race.pl3) {
                        this._store.dispatch(new PagePlaceSelectStart('3'));
                        element.race.pl3 = true;
                      }
                    }
                  }
                  break;
                }
                case '4': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => qf.esito === horse.number);
                    if (qt.length > 0) {
                      horse.quotaPiazzato4 = qt[0];
                      if (!element.race.pl4) {
                        this._store.dispatch(new PagePlaceSelectStart('4'));
                        element.race.pl4 = true;
                      }
                    }
                  }
                  break;
                }
                case '5': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => qf.esito === horse.number);
                    if (qt.length > 0) {
                      horse.quotaPiazzato5 = qt[0];
                      if (!element.race.pl5) {
                        this._store.dispatch(new PagePlaceSelectStart('5'));
                        element.race.pl5 = true;
                      }
                    }
                  }
                  break;
                }
                case '6': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => qf.esito === horse.number);
                    if (qt.length > 0) {
                      horse.quotaPiazzato6 = qt[0];
                      if (!element.race.pl6) {
                        this._store.dispatch(new PagePlaceSelectStart('6'));
                        element.race.pl6 = true;
                      }
                    }
                  }
                  break;
                }
                case '7': {
                  if (quota.info && quota.info.margin) {
                    element.race.lavagna7 = (quota.info.margin / 100).toFixed(2);
                  }
                  break;
                }
                case '8': {
                  if (quota.info && quota.info.margin) {
                    element.race.lavagna8 = (quota.info.margin / 100).toFixed(2);
                  }
                  break;
                }
                case '9': {
                  if (quota.info && quota.info.margin) {
                    element.race.lavagna9 = (quota.info.margin / 100).toFixed(2);
                  }
                  break;
                }
                case '10': {
                  if (quota.info && quota.info.margin) {
                    element.race.lavagna10 = (quota.info.margin / 100).toFixed(2);
                  }
                  break;
                }
                case '14': {
                  if (quota.odds && quota.odds.length > 0) {
                    // console.log(quota.ia);
                    qt = quota.odds.filter((qf) => parseInt(quota.ia.substr(6, 2), 16) === Number(horse.number));
                    if (qt.length > 0 && (horse.hstatus === '1' || horse.hstatus === '5' || horse.hstatus === '6')) {
                      horse.quotaShorstMuzzleX = qt[0];
                      horse.quotaShorstMuzzleX.ia = quota.ia;
                      if (!element.race.shortMx) {
                        element.race.shortMx = true;
                      }
                    }
                  }
                  break;
                }
                case '16': {
                  if (quota.odds && quota.odds.length > 0) {
                    // console.log(quota.ia);
                    qt = quota.odds.filter((qf) => parseInt(quota.ia.substr(6, 2), 16) === Number(horse.number));
                    if (qt.length > 0 && (horse.hstatus === '1' || horse.hstatus === '5' || horse.hstatus === '6')) {
                      horse.quotaLenghtsX = qt[0];
                      horse.quotaLenghtsX.ia = quota.ia;
                      horse.quotaLenghtsX.lengths = parseInt(quota.ia.substr(2, 2), 16);
                      if (!element.race.lenghtsX) {
                        element.race.lenghtsX = true;
                      }
                    }
                  }
                  break;
                }
                case '18': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => parseInt(quota.ia.substr(6, 2), 16) === Number(horse.number));
                    if (qt.length > 0 && (horse.hstatus === '1' || horse.hstatus === '5' || horse.hstatus === '6')) {
                      horse.quotaDispersionX = qt[0];
                      horse.quotaDispersionX.ia = quota.ia;
                      horse.quotaDispersionX.sec = parseInt(quota.ia.substr(2, 2), 16);
                      horse.quotaDispersionX.dec = parseInt(quota.ia.substr(0, 2), 16);
                      if (!element.race.dispersionX) {
                        element.race.dispersionX = true;
                      }
                    }
                  }
                  break;
                }
                case '22': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => parseInt(quota.ia.substr(6, 2), 16) === Number(horse.number));
                    if (qt.length > 0 && (horse.hstatus === '1' || horse.hstatus === '5' || horse.hstatus === '6')) {
                      horse.quotaNonPiazzato2 = qt[0];
                      horse.quotaNonPiazzato2.ia = quota.ia;
                      if (!element.race.notPl2) {
                        element.race.notPl2 = true;
                      }
                    }
                  }
                  break;
                }
                case '23': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => parseInt(quota.ia.substr(6, 2), 16) === Number(horse.number));
                    if (qt.length > 0 && (horse.hstatus === '1' || horse.hstatus === '5' || horse.hstatus === '6')) {
                      horse.quotaNonPiazzato3 = qt[0];
                      horse.quotaNonPiazzato3.ia = quota.ia;
                      if (!element.race.notPl3) {
                        element.race.notPl3 = true;
                      }
                    }
                  }
                  break;
                }
                case '24': {
                  if (quota.odds && quota.odds.length > 0) {
                    qt = quota.odds.filter((qf) => parseInt(quota.ia.substr(6, 2), 16) === Number(horse.number));
                    if (qt.length > 0 && (horse.hstatus === '1' || horse.hstatus === '5' || horse.hstatus === '6')) {
                      horse.quotaNonPiazzato4 = qt[0];
                      horse.quotaNonPiazzato4.ia = quota.ia;
                      if (!element.race.notPl4) {
                        element.race.notPl4 = true;
                      }
                    }
                  }
                  break;
                }
                default: {
                  break;
                }
              }
            });
            // init handicap
            if (handicap || (horse.hdis && horse.hdis > 0 &&
                ((horse.hdis - element.race.distance_value) > 0))
            ) {
              if (!handicap || (handicap && Number(horse.hdis) > 0)) {
                handicap = Number(horse.hdis);
              }
              horse.hdis = String(handicap);
            }
          });
          element.race.lavagna = (element.race.lavagna * 100).toFixed(2);

          if (element.race.horse.every(this.notContainPosition) && !element.race.results) {
            element.race.resultFlag = false;
          } else if (element.race.results) {
            element.race.resultFlag = true;
            element.race.horse.forEach((horse) => {
              horse.finish_pos = Number(horse.finish_pos);

              for (let i = 0; i < element.race.results.split('/').length; i++) {
                for (let j = 0; j < element.race.results.split('/')[i].split('-').length; j++) {
                  if (horse.number === element.race.results.split('/')[i].split('-')[j]) {
                    if (horse.finish_pos <= 0 ) {
                      horse.finish_pos = i + 1;
                    }
                  }
                }
              }
              if (horse.finish_pos <= 0) {
                // aggiungo posizione fittizia per cavalli ritirati
                horse.finish_pos = 99;
              }
            });

            // ordino per posizione arrivo
            element.race.horse = sortBy(element.race.horse, 'finish_pos');
          }
          // aggiungo lavagna
          element.race.placeCount = 0;
          if (element.race.pl2) {
            element.race.placeCount++;
          }
          if (element.race.pl3) {
            element.race.placeCount++;
          }
          if (element.race.pl4) {
            element.race.placeCount++;
          }
          if (element.race.pl5) {
            element.race.placeCount++;
          }
          if (element.race.pl6) {
            element.race.placeCount++;
          }
        }
        // Video
        if (element.race.video) {
          element.race.video = JSON.parse(element.race.video);
        }
        // Tempo / weather
        element.race.weather = element.race.weather.replace(/\s/g, '').toLowerCase();
        return element.race;
      }),
      catchError(this.monitoringService.handleError<IRace>(`getRace id=${id}`, null))
    );
  }

  /**
   * Function to check in position is 0
   * @param value horse
   */
  private notContainPosition(value: IHorse): boolean {
    if (value && value.finish_pos) {
      return value.finish_pos === '0';
    }
    return false;
  }

  /**
   * Call service and return observable of ITotrace
   * @returns Observable<ITotrace>
   */
  getTot(params: string): Observable<ITotrace> {
    return this.http.get<any>(this.apiUrlTot + params).pipe(
      map((obj) => {
        if (obj.eventi) {
          obj.eventi.forEach((horse) => {
            horse.quotetot = obj.quote_generali
              ? obj.quote_generali.filter((q) => q.e === horse.e)
              : [];
            horse.quotepsrvin = obj.quote_combinazioni_psr
              ? obj.quote_combinazioni_psr.filter((q) => q.s === 1 && q.p === horse.e) // scommessa VIN
              : [];
          });
          obj.quoteaccotris = obj.quote_combinazioni_psr
            ? obj.quote_combinazioni_psr.filter((q) => q.s === 8 || q.s === 10) // PSR
            : [];
          if (obj.quoteaccotris.length === 0) {
            obj.quoteaccotris = obj.quote_plurime
              ? obj.quote_plurime.filter((q) => q.s === 7 || q.s === 8 || q.s === 10) // TOT
              : [];
          }
          // obj.quoteaccotris = sortBy([obj.quoteaccotris, (o) => {
          //   return Number(o.q);
          // }, 'asc'], (o) => {
          //   return Number(o.c.split(' - ')[0]);
          // }, (o) => {
          //   return Number(o.c.split(' - ')[1]);
          // }, (o) => {
          //   return Number(o.c.split(' - ')[2]);
          // });

          obj.quoteaccotris.forEach((el) => {
            el.q = Number(el.q);
          });
          obj.quoteaccotris = orderBy(obj.quoteaccotris, ['q', 'c'], ['asc', 'asc']);

          //delete obj['quote_generali'];
          //delete obj['quote_montanti_psr'];
        }
        return obj;
      }),
      catchError(this.monitoringService.handleError<IRace>(`getTot params=${params}`, null))
    );
  }

  excludeBets(quota) {

    if (environment.excludeBet[quota.id].includes(this.token)) {
      return false;
    }
    return true;
  }

  getEvent(id: number): Observable<any> {
    return this.http.get<any>(this.apiUrlSelected + 'rest/program/events/' + id).pipe(
        map((element) => {
          return element.race.filter((race) => race.pers.ss === 'AP');
        }),
        catchError(this.monitoringService.handleError<any>(`getEvent id=${id}`, []))
    );
  }

  getVideoRepley(race: IRace): Observable<IRace> {
      return this.http.get<any>(this.apiUrlSelected + race.video.url).pipe(
          map((element) => {
            race.video.url = element;
            return race;
          }),
          catchError(this.monitoringService.handleError<any>('Get Video Replay', race))
      );
  }

}
